import { inject, Injectable } from '@angular/core';

import { ApiEndpoint } from '../api';
import { environment } from '../environments/environment';
import { BrowserStorageKey } from '../shared/browser-storage/browser-storage.constant';
import { WINDOW } from '../shared/common';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  #window = inject(WINDOW);

  handleSSOReturnRedirect(): void {
    const hasPendingRedirect = this.#window.sessionStorage.getItem(BrowserStorageKey.IsAuthRedirectInProgress) === 'true';

    if (!hasPendingRedirect) {
      return;
    }

    this.#window.sessionStorage.removeItem(BrowserStorageKey.IsAuthRedirectInProgress);
    this.#window.localStorage.setItem(BrowserStorageKey.IsAuthenticated, 'true');
  }

  isSignedIn(): boolean {
    return this.#window.localStorage.getItem(BrowserStorageKey.IsAuthenticated) === 'true';
  }

  isSignedOut(): boolean {
    return !this.isSignedIn();
  }

  loginWithJumpCloud(): void {
    const returnRedirectUrl = this.#window.location.origin;
    const url = new URL(`/${ApiEndpoint.OAuthLogin}`, environment.apiHost);

    url.searchParams.set('ui', 'true');
    url.searchParams.set('returnTo', returnRedirectUrl);
    this.#window.sessionStorage.setItem(BrowserStorageKey.IsAuthRedirectInProgress, 'true');

    this.#window.location.assign(url.toString());
  }

  logout(): void {
    this.#window.localStorage.removeItem(BrowserStorageKey.IsAuthenticated);
  }
}
